import { queryData } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getCropYear = async (id) => {
  return await queryData(`${GlobalConfig.REACT_APP_API_CROPYEAR_URL}${id}`);
};
